export const getQueryStringArgs = () =>
  Object.fromEntries(
    window.location.search
      .slice(1)
      .split('&')
      .filter(kv => !!kv)
      .map(kv => kv.split('='))
      .map(([k, v]) => [k, decodeURIComponent(v)])
  )
